var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoBenutzer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7b68b;}.cls-2{fill:#001f46;}.cls-3{fill:#eaf4fe;}.cls-4{fill:#ec9568;}.cls-5{fill:#fd2227;}.cls-6{fill:#7dc2f5;}.cls-7{fill:#7eb3ff;}.cls-8{fill:#b6c2c9;}.cls-9{fill:#8dcfff;}.cls-10{fill:#acd5f4;}.cls-11{fill:#d0dee6;}.cls-12{fill:#dd000b;}.cls-13{fill:#d7dfe2;}.cls-14{fill:#c5e1f9;}.cls-15{fill:#163f59;}.cls-16{fill:#212a54;}.cls-17{fill:#212957;}.cls-18{fill:#367082;}.cls-19{fill:#9ac7f7;}.cls-20{fill:#88bdda;}.cls-21{fill:#281617;}.cls-22{fill:#387bff;}.cls-23{fill:#3b47bc;}.cls-24{stroke:#9ac7f7;stroke-width:.46px;}.cls-24,.cls-25{fill:none;stroke-miterlimit:10;}.cls-25{stroke:#8dcfff;stroke-width:.24px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "256 116.94 512 210.92 512 354.89 0 354.89 0 210.92 256 116.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "256 450 512 356.03 512 212.05 256 306.03 256 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "256 450 0 356.03 0 212.05 256 306.03 256 450"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m187.35,214.43v4.72h22.29s-3.55-6.4-10.99-7.75c-7.43-1.35-11.31,3.03-11.31,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m168.29,125.1s62.81-1.68,66.75,5.39c5.03,9.04,3,75.33,3,75.33l-7.02,1.35s3.73,1.38,11.53,3.55c7.47,2.08,9.05,6.07,9.05,6.07l-28.67,1.35.56-9.09-4.43-57.48-47.54-.17-3.23-26.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m134.69,141.96s-14.86,2.7-18.09-27.64c-3.23-30.34-4.2-54.61-4.2-54.61l18.42-10.11h16.15s13.57,4.72,14.86,11.46c1.29,6.74-3.23,33.71-1.29,38.43,1.94,4.72,9.05,20.23,9.05,20.23l-34.89,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m161.83,61.06s15.51,17.53,18.09,26.63c2.58,9.1,6.46,18.2,1.94,21.57-4.52,3.37-7.43,5.06-8.72,3.03-1.29-2.02-20.68-25.28-11.31-51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m169.91,91.4h-8.39c-1.07,0-1.63-.91-1.26-2.03l6.38-18.87c.38-1.12,1.56-2.03,2.63-2.03h8.39c1.07,0,1.63.91,1.26,2.03l-6.38,18.87c-.38,1.11-1.56,2.03-2.63,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.35,97.8l12.01-8.83,2.21-1.62s3.88,6.07,2.26,10.11c-1.62,4.05-13.25,6.74-15.18,6.4-1.94-.34-1.29-6.07-1.29-6.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "166.68 89.04 165.71 97.8 160.54 99.49 159.57 87.35 166.68 89.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m176.05,88.02l-1.29,12.14-6.78-3.03s0-9.1,1.29-10.11c1.29-1.01,5.17-5.73,6.78,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m129.52,139.94s5.82-19.55,23.91-22.25c18.09-2.7,21.32-2.7,21.32-2.7,0,0,12.28,17.53,25.2,93.04.51,2.97-16.15,8.09-16.15,8.09l-19.39-67.42s-24.55,8.09-34.89-8.76Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 162.15,
    y1: 133.53,
    x2: 183.8,
    y2: 216.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.12,66.79s-6.46-9.78-9.05-7.08c-2.58,2.7-12.92,32.36-12.28,41.8.65,9.44,1.28,16.71,7.75,17.19,22.62,1.69,40.39-11.8,40.39-11.8l-1.62-13.82s-25.85,1.69-27.79,3.71c-1.94,2.02,1.94-19.89,2.58-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m133.24,16.51s7.66.92,10.15-2.05c2.49-2.97-4.59-2.2-1.47.1,3.12,2.3,10.33-1.43,8.54-5.2-1.79-3.76-4.73-5.45-7.67-3.37-2.95,2.08-.62,3.38.53,1.29,1.15-2.08-3.09-7.37-6.99-.14-3.9,7.23-1.92,7.86-.52,3.03,1.4-4.82-1.47-7.99-3.83-2.34-2.36,5.65.93,8.57,1.85,6.04.92-2.53-6.11-8.14-6.8-3.28-.69,4.86-1.3,10.68,2.25,10.87,3.55.18-4.38-12.86-7.92-2.51-3.55,10.35,3.09,7.37,3.41,5.03.32-2.34-12.02,1.65-2.64,5.37,9.38,3.72,5.93-.57,6.8-2.93.87-2.36-8.09,3.65-3.48,8.87,4.61,5.22,9.17,4.41,8.38-.92-.79-5.33-6.24-2.73-4.65,1.73,1.59,4.45-1.13,6.98-2.15,7.41-1.03.43,6.43,3.92,8.02-.29,1.58-4.2,4.2-25-1.79-26.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.98,21.3l.11-2.22-4.2-6.03s-.39,1.95-7.46,2.72c-10.55,1.15-1.42,4.25-1.02,9.08.22,2.64-.37,4.51-1.13,5.3,2.12,4.1,4.75,7.65,7.61,10.28.02-.11.04-.17.04-.17l4.47,1.98c4.47,1.98,3.96-3.07,3.96-3.07l-.52-9.38,1.78-3.01-3.64-5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.98,21.3l.11-2.22-4.2-6.03s-.39,1.95-7.46,2.72c-10.55,1.15-1.42,4.25-1.02,9.08.4,4.83-1.89,7.11-3.04,4.87-1.15-2.24-4.78-3.39-6.52-1.12-1.74,2.27,3.17,6.46,4.28,7,1.11.54,1.92.23,1.92.23,0,0-4.02,11.55-6.11,17.25,1.14.83,9.9,1.53,13.35,0,.52-4.89,2.64-12.81,2.64-12.81l4.47,1.98c4.47,1.98,3.96-3.07,3.96-3.07l-.52-9.38,1.78-3.01-3.64-5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m341.87,48.1s10.28-9.13,2.35-23.63c-4.39-8.04-2.09-29.99,12.13-23.18,14.23,6.81,10.37-1.68,18.4,2.11,8.04,3.79,11.59,9.49,10.5,15.71-1.08,6.22-.38,18.07,4.56,20.35,4.94,2.28,28.6,15.02,13.35,31.12-15.25,16.1-70.69,4.28-61.3-22.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m390.08,164.96c1.78,0,4.59-.41,7.05-2.55,3.54-3.08,5.07-8.56,4.56-16.28-.35-5.21-2.4-10.49-4.57-16.07-3.66-9.4-7.8-20.05-5.63-34.13l-4.02-.62c-2.33,15.17,2.21,26.84,5.86,36.23,2.15,5.51,4,10.28,4.31,14.87.42,6.26-.66,10.72-3.13,12.9-2.34,2.07-5.26,1.54-5.38,1.51l-.82,3.99c.07.01.76.15,1.79.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m358.86,197.26l-3.96,6.05,33.3,10.67s2.23-2.13-5.95-6.4c-9.51-4.98-23.39-10.32-23.39-10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m352.95,197.26l3.96,6.05-33.3,10.67s-2.22-2.13,5.95-6.4c9.51-4.98,23.39-10.32,23.39-10.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 352.43,
    y: 179.28,
    width: 6.96,
    height: 24.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m359.31,198.54l-3.39,5.77,28.51,10.18s1.9-2.03-5.09-6.11c-8.15-4.75-20.03-9.84-20.03-9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m352.51,198.54l3.39,5.77-28.51,10.18s-1.9-2.03,5.09-6.11c8.15-4.75,20.03-9.84,20.03-9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.2,216.78c0,1.33,1.08,2.42,2.42,2.42s2.42-1.08,2.42-2.42-1.08-2.42-2.42-2.42-2.42,1.08-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m325.96,216.78c0,1.33,1.09,2.42,2.42,2.42s2.42-1.08,2.42-2.42-1.08-2.42-2.42-2.42-2.42,1.08-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m387.05,216.78c0,1.33,1.08,2.42,2.42,2.42s2.42-1.08,2.42-2.42-1.08-2.42-2.42-2.42-2.42,1.08-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m320.11,216.78c0,1.33,1.08,2.42,2.42,2.42s2.41-1.08,2.41-2.42-1.08-2.42-2.41-2.42-2.42,1.08-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 353.45,
    y: 170.2,
    width: 5.09,
    height: 8.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m349.63,165.49c0,2.74,2.22,4.96,4.96,4.96h2.8c2.74,0,4.96-2.22,4.96-4.96h0c0-2.75-2.22-4.97-4.96-4.97h-2.8c-2.74,0-4.96,2.22-4.96,4.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m318.16,160.95c-.12-.58-.19-4.25-.19-4.88,0-4.01,2.59-7.25,5.79-7.25h64.48c3.19,0,5.78,3.25,5.78,7.25,0,.63-.07,4.29-.19,4.88h-75.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m394.62,162.91c0,1.23-.72,2.22-1.6,2.22h-74.03c-.89,0-1.6-1-1.6-2.22h0c0-1.23.72-2.22,1.6-2.22h74.03c.89,0,1.6.99,1.6,2.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m391.01,123.72c-1.59.12-11.7.3-13.44.32-11.06.13-20.59-1.94-21.12-4.67-2.18-11.32-2.28-22.93-.29-34.26.47-2.72,10.14-4.8,21.44-4.66,1.77.02,12.09.2,13.71.32-3.47,14.12-3.57,28.83-.3,42.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m392.53,80.77c1.24.01,2.1.6,1.93,1.31-3.08,13.28-3.2,27.05-.35,40.34.16.71-.7,1.3-1.91,1.31h0c-1.21.02-2.33-.55-2.49-1.26-2.89-13.31-2.8-27.12.26-40.43.17-.71,1.31-1.28,2.55-1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m393.02,123.7c-.33.1-2.52.19-2.9.19-2.41.03-4.89-2.1-5.37-4.78-2.01-11.15-1.96-22.59.16-33.74.5-2.68,3.05-4.8,5.51-4.78.39,0,2.62.09,2.95.2-3.47,14.1-3.59,28.8-.34,42.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m373.66,31.39s-3.03,15.17-1.01,20.56c2.02,5.39-13.82,1.35-13.82,1.35,0,0,.67-12.47,1.01-15.17.34-2.7,13.82-6.74,13.82-6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m359.12,38.77c.31-2.47,12.68-6.19,12.68-6.19,0,0-9,13.05-12.06,13.3-.42.04-.8.03-1.15-.02.18-2.94.39-5.96.53-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m351.38,18.66s-.93,12.68.62,16.4c1.55,3.71,2.17,6.5,5.88,6.19,3.71-.31,9.59-5.88,12.99-8.04,3.4-2.17,5.88-4.64,4.64-7.73-1.24-3.09-2.78-.62-2.78.31s-9.59,2.47-17.01-2.17c-1.85-1.16-4.64-3.09-4.33-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m358.72,114.01l-32.43-26.31s-6.2.68-3.29,4.64c2.91,3.96,22.13,27.2,22.13,27.2,0,0,19.62,8.91,13.58-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m357.82,52.96s-12.81,2.02-14.49,7.08c-1.69,5.06-1.01,8.09-1.01,10.45s16.18-8.43,15.51-17.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m371.64,51.27l-13.82,1.69s-15.51,16.18-18.88,16.85c-3.37.67,1.17,37.59.34,42.59-.45,2.7,12.14,3.93,18.88,4.94,6.74,1.01,16.18,0,16.18,0,0,0-3.37-10.79-1.01-21.91,2.36-11.12,12.81-19.55,10.45-27.3-2.36-7.75,4.38-7.75-12.14-16.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m381.41,60.38s-3.71,10.45-3.03,17.19c.67,6.74,2.7,23.26,2.7,23.26,0,0,4.05,19.21,11.8,16.85,7.75-2.36,7.08-24.27,1.69-38.09-5.39-13.82-10.79-22.58-13.15-19.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m396.76,110.99s-.34,3.88-.34,4.72-3.71,1.85-7.58,1.85-32.53-16.52-35.23-17.7c-2.7-1.18-8.93-2.87-10.45-3.03-1.52-.17-2.7-4.38-1.85-7.08.56-1.78,1.12-3.35,1.97-3.86.43-.26.95-.25,1.57.15,1.85,1.18,9.27,7.58,9.27,7.58,0,0,17.36,3.2,24.27,6.24,6.91,3.03,15,6.74,18.37,11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m334.4,87.06l8.88-1.16-1.97,3.86,1.18,5.9-4.89.84s-.67-.84.17-1.18c.84-.34,2.02-.84,2.02-.84,0,0-2.36-.34-3.37-.51-1.01-.17-1.18-.51-1.18-1.01s1.01-.84,1.01-.84c0,0-1.85-.67-2.02-1.18-.17-.51-.51-1.18-.17-1.69.34-.51-.17-1.85.34-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m352.02,121.39l-42.25-7.64s-13.48-3.6-16.18,8.99c-3.14,14.67-9.89,80-9.89,80l-.45,3.15-20.67,11.24h31.46l-2.25-9.89,18.88-66.52s32.36,9.44,43.15,9.44,18.88-4.05,18.88-5.84-13.03-23.82-20.67-22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m312.44,207.76s-1.31,2.62-1.31,3.97-6.45,5.17-6.67,6.29l-.22,1.12h18.5s-.81-10.11-1.26-13.82c-.45-3.71-9.02,2.44-9.02,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m374.33,117.34h-16.18l-47.04-10.34s-18.88-4.94-13.93,8.54c4.94,13.48,13.95,88.96,13.95,88.96l10.34.86s6.12-52.52,1.18-61.06c-4.94-8.54-5.39-11.24-5.39-11.24,0,0,32.81,17.53,46.29,16.63,13.48-.9,24.72-11.24,10.79-32.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m369.99,118.69s8.99,15.73.45,17.53c-8.54,1.8-62.92-18.43-62.92-18.43,0,0,6.15,22.47,13.95,84.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m337.08,91.1s.02-.04.03-.06l-.03-1.8h-74.35v1.8s-.01.04,0,.06l.19.33c.96,1.56,2.67,1.84,4.63,1.84h64.7c1.96,0,3.68-.28,4.63-1.84l.19-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m319.16,91.4s-.01.03,0,.05l.18.27c.29.4.66.7,1.09.91h11.31c1.89,0,3.54-.23,4.46-1.48l.18-.27s.02-.03.03-.05l-.02-.88h-17.23v1.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 271.97,
    y: 89.66,
    width: 37.15,
    height: 1.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m318.75,89.18l-9.64-36.53c-.26-.97-1.24-1.75-2.2-1.75h-52.16c-.96,0-1.54.78-1.28,1.75l9.64,36.53h55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m289.25,70.04c.49,1.86-.62,3.38-2.49,3.38s-3.78-1.51-4.27-3.38c-.49-1.87.62-3.38,2.49-3.38s3.78,1.51,4.27,3.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "162.95 218.77 155.34 218.77 167.9 97.17 178.93 97.17 162.95 218.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "178.2 102.77 173.36 139.6 167.62 99.91 167.9 97.17 177.54 97.17 178.2 102.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "264.9 218.77 257.3 218.77 269.85 97.17 280.89 97.17 264.9 218.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "280.15 102.77 275.31 139.6 269.57 99.91 269.85 97.17 279.5 97.17 280.15 102.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "344.8 218.77 352.41 218.77 339.86 97.17 328.82 97.17 344.8 218.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "329.56 102.77 344.33 140.3 340.14 99.91 339.86 97.17 330.21 97.17 329.56 102.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 258.76,
    y: 93.22,
    width: 91.75,
    height: 7.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 158.82,
    y: 93.22,
    width: 104.18,
    height: 7.11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoBenutzer);
export default __webpack_public_path__ + "static/media/Demo_Benutzer.14bbbb6c1c54e62869d32b27fe796b4c.svg";
export { ForwardRef as ReactComponent };